/**
 * "Dinamika": McCabe-Thiele faqat turg'un usul. MODEL_GUIDE 2-band bo'yicha `step`
 * har qadamda `steady` ni chaqiradi va holatga vaqtni yozadi — UI bir xil ishlaydi.
 */
import type { StepResult } from '../../types';
import { solveSteady } from './steady';
import type {
  RectificationInputs,
  RectificationOutputs,
  RectificationParams,
  RectificationState,
} from './types';

export function initState(
  _params: RectificationParams,
  _inputs: RectificationInputs,
): RectificationState {
  return { t: 0 };
}

export function stepDynamic(
  params: RectificationParams,
  state: RectificationState,
  inputs: RectificationInputs,
  dt: number,
): StepResult<RectificationState, RectificationOutputs> {
  if (!(dt > 0)) throw new Error('rectification-column: dt must be > 0');
  const r = solveSteady(params, inputs);
  return { state: { t: state.t + dt }, outputs: r.outputs, warnings: r.warnings };
}
